<template>
    <main id="modal" class="flexContainers">
        <div id="spinnerLoader" class="flexContainer abs" v-if="loading">
            <Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
        </div>
        <div class="wishlist" v-if="getBook.hasOwnProperty('vide') === false">
            <header class="wishlist-header"><i class="icon-close" @click="closeModal();"></i></header>
            <div class="modalBody">
                <div key="brand" v-if="Object.keys(this.getBook.data).length > 0">
                    <div>
                        <div>
                            <div class="modalBody">
                                <div class="modalContent">
                                    <h1 class="listTitle titleName">{{ getBook.name }}</h1>
                                    <img
                                        src="../../../static/assets/mod-icon.svg"
                                        class="pointer fright icone"
                                        v-if="avtivIconeMod === false"
                                        @mouseover="avtivIconeMod = true;"
                                        alt=""
                                        height="25"
                                        width="25"
                                    />
                                    <img
                                        src="../../../static/assets/mod-icon-red.svg"
                                        class="pointer fright icone"
                                        v-if="avtivIconeMod === true"
                                        alt=""
                                        @mouseleave="avtivIconeMod = false;"
                                        height="25"
                                        width="25"
                                        @click="updateList();"
                                    />
                                    <img
                                        src="../../../static/assets/delete-icon.svg"
                                        class="pointer fright icone"
                                        v-if="avtivIconeDel === false"
                                        @mouseover="avtivIconeDel = true;"
                                        alt=""
                                        height="25"
                                        width="25"
                                    />
                                    <img
                                        src="../../../static/assets/delete-icon-red.svg"
                                        class="pointer fright icone"
                                        v-if="avtivIconeDel === true"
                                        alt=""
                                        height="25"
                                        width="25"
                                        @mouseleave="avtivIconeDel = false;"
                                        @click.prevent.stop="deleteList(getBook);"
                                    />
                                    <img
                                        src="../../../static/assets/download.svg"
                                        class="pointer fright icone"
                                        alt=""
                                        v-if="avtivIconeDow === false"
                                        v-show="showIconDow"
                                        @mouseover="avtivIconeDow = true;"
                                        height="25"
                                        width="25"
                                    />
                                    <img
                                        src="../../../static/assets/download-red.svg"
                                        class="pointer fright icone"
                                        alt=""
                                        v-if="avtivIconeDow === true"
                                        v-show="showIconDow"
                                        height="25"
                                        width="25"
                                        @mouseleave="avtivIconeDow = false;"
                                        @click="exportPdf(getBook);"
                                    />
                                    <div class="wishlist-name" v-if="editName">
                                        <input type="text" v-model="getBook.name" /> <button @click="saveUpdate();">OK</button>
                                    </div>
                                    <div class="flexContainer ai-c jc-sb listComponent" :key="index" v-for="(n, index) in getBook.data.components">
                                        <span class="componentName"
                                            >{{ n.name[$t("trad")]["value"] }}&#160;&#160;&#160;{{
                                                n.type.name ? "[ " + n.type.name + " ]" : ""
                                            }}</span
                                        >
                                        <img
                                            src="../../../static/assets/delete-icon.svg"
                                            width="20"
                                            height="20"
                                            alt=""
                                            class="trashBean pointer fright"
                                            @click="deleteComponent(getBook, n);"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div key="brand" v-if="Object.keys(this.getBook.data).length === 0">
                    <div>
                        <div>
                            <div class="modalBody">
                                <div class="modalContent">
                                    <h1 class="listTitle titleName" v-if="getBook.hasOwnProperty('vide')">{{ getBook.vide }}</h1>
                                    <h1 class="listTitle titleName" v-else="">{{ getBook.name }}</h1>
                                    <div class="flexContainer ai-c jc-sb listComponent">
                                        <span class="componentNameVide center bold">BOOK VIDE {{ getBook.length }}</span>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Globals from "../globals.js";
import httpService from "../service";
import Spinner from "vue-simple-spinner";

export default {
    data() {
        return {
            loading: false,
            editName: false,
            avtivIconeMod: false,
            avtivIconeDel: false,
            avtivIconeDow: false
        };
    },
    watch: {},
    components: {
        Spinner
    },
    mounted() {},
    methods: {
        ...mapActions({
            searchList: "catalog/wishlist/searchList",
            saveList: "catalog/wishlist/saveList",
            setDisplay: "catalog/wishlist/setDisplay",
            cleanToAddList: "catalog/wishlist/cleanToAddList",
            setDisplayAddList: "catalog/wishlist/setDisplayAddList",
            deleteListAction: "catalog/wishlist/deleteList",
            addComponentsToList: "catalog/wishlist/addComponentsToList",
            deleteComponentToList: "catalog/wishlist/deleteComponentToList"
        }),
        exit() {
            window.location.replace("/");
        },
        saveUpdate() {
            this.loading = true;
            this.saveList(this.getBook).then(res => {
                this.loading = false;
                this.editName = false;
            });
        },
        deleteList(book) {
            this.$swal({
                title: "",
                text: this.$t("wishlist.messageAlertDelete"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: this.$t("wishlist.btYes"),
                cancelButtonText: this.$t("wishlist.btNo")
            }).then(result => {
                if (result === true) {
                    this.deleteListAction(book);
                    location.reload();
                }
            });
        },
        updateList(list, index) {
            this.editName = true;
        },
        closeModal() {
            this.$emit("hideBookModal");
        },
        exportPdf(list) {
            this.loading = true;
            httpService.get("/wishlists/" + list.id + "/pdf").then(response => {
                this.loading = false;
                if (response.status === 400 || response.code === 400) {
                    alert(response.message);
                } else {
                    let url = Globals.getBaseUrl() + response.url;
                    window.open(url);
                }
            });
        },
        deleteComponent(list, component) {
            this.deleteComponentToList({ list: list, component: component });
            this.saveList(list).then(res => {});
        }
    },
    computed: {
        ...mapGetters({
            getBook: "catalog/wishlist/getBook"
        }),
        showIconDow: function() {
            return this.getBook.data.components.length && this.getBook.data.components.length;
        }
    },
    created() {}
};
</script>

<style lang="scss" scoped>
.icone {
    margin-top: 15px;
    margin-right: 2px;
}
.componentName {
    padding-left: 12px;
}
.componentNameVide {
    padding-left: 12px;
}
.trashBean {
    margin-right: 12px;
}
.titleName {
    display: inline-block;
    vertical-align: middle;
}
#spinnerLoader {
    left: 0;
    top: 50%;
    width: 100%;
    background-color: transparent;
    .loader {
        margin: auto;
    }
}
.listComponent {
    margin-bottom: 10px;
    height: 46px;
    background-color: #f3f3f3;
    border-bottom: 1px solid #c2c2c2;
}
.cancel {
    margin-right: 10px;
}
.logoRem3rch {
}

.selectCampaign {
    border: none;
    border-bottom: 1px solid #343434;
    width: 100%;
    font-size: 14px;
    font-family: Roboto;
}

.zones {
    overflow-y: scroll;
    height: 100px;
}

.boutonSaveDelete {
    margin-left: 290px;
    .save {
        margin-right: 12px;
    }
}

.help {
    margin-top: 20px;
    margin-left: 262px;
}

#spinnerLoader {
    left: 0;
    top: 50%;
    width: 100%;
    .loader {
        margin: auto;
    }
}

.teinteCert {
    padding-left: 60px;
}

.zoneChecked {
    margin-left: 2px;
}

.campaignTable {
    width: 40%;
    padding-bottom: 12px;
}

.productShadeTitle {
    font-family: "Oswald", Sans-Serif;
}

.inputShades {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
}

.labelInput {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 1.17em;
    padding-left: 20px;
    padding-right: 10px;
}

.labelInputShades {
    margin-top: 2px;
    font-family: Roboto;
    font-size: 1.17em;
    padding-right: 10px;
}

/* height firefox modal */
._modalWrapper_ {
    height: auto;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 77px;
        right: 300px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            background: #fff;
            width: 900px;
            height: auto;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
#spinnerLoader {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    top: 0;
    left: 0;
    border-radius: 3px;
    .loader {
        margin: auto;
    }
}

#modal {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    padding-bottom: 20px;
    top: 0;
    left: 0;
    /*margin: auto;*/

    .wishlist {
        padding: 12px;
        position: absolute;
        left: calc(50% - 250px);
        top: 20px;
        display: flex;
        max-height: 650px;
        flex-direction: column;
        height: 100%;
        width: 500px;
        background-color: #fff;
        margin: 10px;
        .wishlist-header {
            .icon-close {
                position: absolute;
                right: 15px;
                top: 15px;
                height: 28px;
                width: 28px;
                background-image: url("../../assets/croix.png");
                background-size: 100% auto;
                cursor: pointer;
            }
            padding-left: 20px;
            .title {
                font-size: 25px;
                font-weight: bold;
                color: #000;
                font-family: "Oswald", Sans-Serif;
                /*padding: 5px 20px;*/
            }

            h3 {
                font-size: 15px;
            }
        }

        .wishlist-main {
            flex: 1;
            padding: 10px;
            overflow-y: auto;
            position: relative;

            .delete-component {
                position: absolute;
                background-image: url("../../assets/croix.png");
                background-size: 16px;
                right: 10px;
                height: 16px;
                width: 16px;
            }

            .delete-list {
                /*padding-top: 25px;*/
                /*text-align: right;*/
                background-color: transparent;
                border: none;
                color: #fff;
                font-size: 12px;
                margin-right: 5px;
                cursor: pointer;
            }

            .content-components {
                /*padding-top: 20px;*/
                /*padding-bottom: 25px;*/
                padding-left: 20px;
                .content-component {
                    font-size: 12px;
                    position: relative;
                    padding-bottom: 12px;
                }
            }

            .content-btn-export {
                position: absolute;
                right: -5px;
                top: 7px;
                border: none;
                font-size: 10px;
                padding: 2px 10px 2px 10px;
                .btn-exp-wishlist {
                    padding: 5px 20px;
                    font-size: 12px;
                }
            }

            .content-list {
                /*padding: 10px;*/
                padding-top: 10px;
                font-size: 20px;
                border-bottom: 1px solid #c2c2c2;
                cursor: pointer;
                background-color: #f3f3f3;
                margin-top: 10px;
                position: relative;
                .wishlist-name {
                    /*display: inline-block;*/
                    padding-left: 10px;
                    font-size: 18px;
                    font-family: "Oswald", Sans-Serif;
                }

                .content-wishlist-action {
                    background-color: #b30019;
                    color: #ffffff;
                    margin-top: 15px;
                    .content-wishlist-action-btn {
                        text-align: right;
                    }
                }
            }
        }

        .wishlist-footer {
            padding: 10px;

            button {
                width: 100%;
                color: black;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// modalBook.vue?ce5a3f62